import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';

/**
 * The set of object types that are displayed in the Library.
 */
export type LibraryObjectType = Exclude<
  ObjectType,
  | ObjectType.ELEMENT
  | ObjectType.EVENT
  | ObjectType.API_EVENT
  | ObjectType.PAGE_TYPE
  | ObjectType.SPACE
  | ObjectType.TEXT
  | ObjectType.UNKNOWN
  | ObjectType.SPEC_OBJECT_MAPPING
  | ObjectType.SPEC_PROPERTY_MAPPING
  | ObjectType.PROPERTY
>;

/**
 * In order of appearance on the tag filters.
 */
export const ALL_LIBRARY_OBJECT_FILTERS: LibraryObjectType[] = [
  ObjectType.DASHBOARD,
  ObjectType.DATA_TABLE,
  ObjectType.SEGMENT,
  ObjectType.METRIC,
  ObjectType.FUNNEL,
  ObjectType.RETENTION,
  ObjectType.JOURNEY,
  ObjectType.HEATMAP,
];

export type LibraryObjectFilterParamValue =
  | 'dashboards'
  | 'segments'
  | 'metrics'
  | 'funnels'
  | 'retentions'
  | 'journeys'
  | 'heatmaps'
  | 'dataTables';

export const TYPE_FILTER_PARAM_VALUES: {
  [key in LibraryObjectType]: LibraryObjectFilterParamValue;
} = {
  [ObjectType.DASHBOARD]: 'dashboards',
  [ObjectType.SEGMENT]: 'segments',
  [ObjectType.METRIC]: 'metrics',
  [ObjectType.FUNNEL]: 'funnels',
  [ObjectType.RETENTION]: 'retentions',
  [ObjectType.JOURNEY]: 'journeys',
  [ObjectType.HEATMAP]: 'heatmaps',
  [ObjectType.DATA_TABLE]: 'dataTables',
} as const;

export const TYPE_FILTER_PARAM_KEY = 'type';

export enum LibraryFilterQueryValue {
  active = 'active',
  archived = 'archived',
  recent = 'recent',
  starred = 'starred',
  mine = 'mine',
  private = 'private',
}
